// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"811a7594","453":"c707d143","455":"b0eccb5b","977":"4d83bce1"}[chunkId] + ".chunk.js";
};